import { Space } from 'antd';
import type { MenuProps } from 'antd';
import Icon from '@nxsys/components/AppIconImage';
import { IconSortDescending } from '@nxsys/assets/icons';
import { StyledAppDropdown } from './index.styled';

type OptionType = {
  label: string;
  value: string;
};
type AppSelectProps = {
  options: OptionType[];
  onChange: (option: OptionType) => void;
  name?: string;
  [x: string]: any;
};
const AppMenuFilter = ({
  options,
  onChange,
  name = 'Filter',
  ...rest
}: AppSelectProps) => {
  const items: MenuProps['items'] = options.map((option) => {
    return {
      key: option.value,
      label: option.label,
      onClick: () => {
        onChange(option);
      },
    };
  });

  return (
    <StyledAppDropdown menu={{ items }} trigger={['click']} {...rest}>
      <Space>
        <Icon src={IconSortDescending} alt="Sort" />
        {name}
      </Space>
    </StyledAppDropdown>
  );
};

export default AppMenuFilter;
